<mat-form-field appearance="fill" class="w-100">
  <mat-label>{{ label }}</mat-label>
  <input
    type="text"
    matInput
    [formControl]="control"
    [matAutocomplete]="auto"
    [required]="required"
    [placeholder]="placeholder || 'Nhập để tìm...'"
    (blur)="onTouched()"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="onSelection($event.option.value)"
  >
    <mat-option
      *ngFor="let option of filteredOptions | async"
      [value]="option[displayKey]"
    >
      {{ option[displayKey] }}
    </mat-option>
  </mat-autocomplete>
  <mat-error *ngIf="control?.invalid && (control?.touched || control?.dirty)">
    {{ label }} là bắt buộc.
  </mat-error>
</mat-form-field>
